import React from "react";
import { Redirect } from 'react-router-dom';
import RegistrationForm from '../Forms/RegistrationForm.jsx';
import { Constants } from '../Core/Constants';
import LostPasswordSend from '../Components/LostPasswordSend.jsx';
import { UserProvider } from '../Providers/UserProvider';



export default class LostPassword extends React.Component {
    state = {
		success: false,
		email:''
    }

    handleLostPassword = (e) => {
		e.preventDefault();
		UserProvider.sendResetPassword(this.state.email, () => {
			this.setState({ success: true });
		});

    };

    render() {
        if (this.state.success) {
            return <LostPasswordSend />;
        }
        else {
            let T = window.Texts.login;
            return (
                <div className="lost-password-page">
                    <div className="cover">
                        <div className="headline">
                            <h1>{T.lostPasswordTitle}</h1>
                        </div>
                        <div className="inner-500">
                            <div className="LostPassword_Text">
                                <p><strong>{T.lostPasswordText}</strong></p><p>{T.lostPasswordDescription}</p>
                            </div>
                            <form method="post" onSubmit={(e) => this.handleLostPassword(e)}>
                                <div>
                                    <div className="form-group">
										<label> {T.email}</label>
										<input name="UserName" required type="text" id="UserName" className="form-control" onChange={(e) => this.setState({ email: e.target.value })} />
                                    </div>
                                    <button type="submit" className="btn btn50">{T.send}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>);
        }
    }
}